import React from 'react';
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import LazyLoader from '../Common-features/LazyLoader';

function ServiceFeatures({data1, data}) {

  useEffect(() => {
    AOS.init({
        once:false,
    });
  }, [])


  return (
    <>
      <section className='devl-features'>
        <div className='container'>
          <div className='top-head'>
            <h2 className='ttl1'>Features</h2>
          </div>
          <div className='features-list'>
          {data.map((response, index) => (
            <div className='features-itms' key={index}>
              <div className='itm-lft-cont'>
                  <LazyLoader src={response.FeatImg} alt={response.FeatImgAltTag} width="286" height="267" />
              </div>
              <div className='itm-rght-cont'>
                <p>{response.featureDescriptiom}</p>
              </div>
            </div>
            ))}
            
          </div>
        </div>
      </section>
    </>

  )
}

export default ServiceFeatures;
